import styled, { css } from 'styled-components';
import { color } from 'styles/settings';
import { font } from 'styles/settings/typography';
import { withModifiers } from 'utils/styles';

export const globalLinkIndicatorClassName = 'Cortlex-Text-Global-Indicator';

export const visibleCss = css`
  opacity: 1;
  z-index: 2;
`;

export const Container = styled.span.attrs({
  className: globalLinkIndicatorClassName,
})`
  opacity: 0;
  z-index: -1;
  transition: opacity 0.5s ease-in;
  display: block;
  position: absolute;
  box-sizing: border-box;
  user-select: none;

  ${({ isVisible }) => (isVisible ? visibleCss : '')}

  > * {
    pointer-events: auto;
  }

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const BubbleContainer = styled.div`
  position: relative;
  height: ${({ height }) => height}px;
`;

export const Section = styled.div`
  position: absolute;
  bottom: ${({ height }) => height / 2 - 5}px;
  left: 2px;
`;

export const Bubble = styled.span`
  display: block;
  width: 25px;
  height: 25px;
  background-color: ${color.brand.blue};
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  font-size: 16px;
  position: relative;
  left: 5px;
  top: 3px;
  z-index: 2;
  ${font.content.semiBold};
  color: ${color.neutral.white};

  ${withModifiers('isVisible')`
    cursor: pointer;
  `}
`;
